import React, {useEffect, useRef, useState} from "react";
import { useTranslation } from 'react-i18next';

// Components
import TextWithLinks from "sharedComponents/TextWithLinks";

// Utils
import validateExplanationField from "utils/validateExplanationField";

// Hooks
import useDropoutSurveyField from "Hooks/useDropoutSurveyField";
import { findDOMNode } from "react-dom";


const ShortText = ({fieldData, getAnswer, handleChangeSurveyCompletionStatus, mandatoryRefs, disabled = false}) => {
    const shortTextRef = useRef();
    const shortRef = useRef();
    const [showError, SetShowError] = useState('');
    const [shortTextVal, SetShortTextVal] = useState(null);
    const { t } = useTranslation();
    useDropoutSurveyField(shortTextVal, '', handleChangeSurveyCompletionStatus);

    useEffect(() => {
        if (getAnswer.constructor !== Boolean) {
            const answer = shortTextRef.current?.value?.trim();

            getAnswer(prevState => ({
                ...prevState,
                [fieldData.id]: {answer, explanation: ""}
            }));
            (!answer?.length && fieldData.mandatory) && SetShowError('Required');
        }
    }, [getAnswer, fieldData]);

    useEffect(() => {
        const fieldNode = findDOMNode(shortRef.current);
        if (fieldData.mandatory) {
            if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                mandatoryRefs.push(fieldNode);
            }
        }
    }, [fieldData]);

    const handleChange = (e) => {
        SetShortTextVal(e.target.value);
        SetShowError(validateExplanationField(e.target.value, fieldData.mandatory, 'medium'));

        if (!e?.target?.value) {
            const fieldNode = findDOMNode(shortRef.current);
            if (fieldData.mandatory) {
                if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                    mandatoryRefs.unshift(fieldNode);
                }
            }
        }
    };

    return (
        <div
            ref={shortRef}
            className={`single_sect ${showError ? "invalid" : ""}`}>
            <h3 className="single_sect_primary_text">
                {fieldData.label}
                {!!fieldData.mandatory && <sup>*</sup>}
            </h3>
            <TextWithLinks className="single_sect_secondary_text">
                {fieldData.description}
            </TextWithLinks>
            <div className="input_field">
                <input
                    defaultValue={fieldData?.answers?.answer}
                    ref={shortTextRef}
                    name="short_text"
                    type="text"
                    placeholder={t("Please add an answer")}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </div>
            <div className="error_sect">
                {showError}
            </div>
        </div>
    )
}

export default React.memo(ShortText);
